import { useState, useEffect } from 'react';

const useTimeout = (timeoutValue: number): boolean => {
	const [load, setLoad] = useState(false);

	useEffect(() => {
		const timeout = setTimeout(() => {
			setLoad(true);
		}, timeoutValue);
		return () => {
			return clearTimeout(timeout);
		};
	}, []);
	return load;
};
export default useTimeout;
